import styled from 'styled-components';
import { FC, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

const StyledSection = styled.section`
  background-color: ${(props) =>
    props.theme.palette.mode === 'light' ? '#f1f1f1' : props.theme.palette.background.default};
  padding: ${(props) => props.theme.spacing(2)};
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

const Section: FC<Props> = ({ children }) => {
  return <StyledSection>{children}</StyledSection>;
};

export default Section;
